import type {AnchorHTMLAttributes} from 'react';
import {PRODUCT_ENTRY_LABEL} from '../src/product';
import {useHermes} from './lib/store';
import {APP_BASE, Link} from './router';

/** Public entry starts with registration; returning customers keep their workspace. */
export function ProductEntryLink({workspaceHref = `${APP_BASE}/workspace`, ...props}:
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'children'> & {workspaceHref?: string}) {
  const {state} = useHermes();
  return <Link {...props} href={state.session.data ? workspaceHref : `${APP_BASE}/register?${new URLSearchParams({next: workspaceHref})}`}>{PRODUCT_ENTRY_LABEL}</Link>;
}
